import omitBy from "lodash/omitBy";
import { FiltersV2 } from "PFTypes/filters_v2";

export const getVisibleFilters = (filters: FiltersV2) => omitBy(filters, ({ hidden }) => hidden);
